import moment from "moment";

import { appConfig } from "../../configs";
import { DatePicker } from "../../components";

import { CustomersSummary } from "./CustomersSummary";
import { IHomeViewProps } from "./Home";
import { MerchantsSummary } from "./MerchantsSummary";
import { PaymentsSummary } from "./PaymentsSummary";
import { PayoutsSummary } from "./PayoutsSummary";
import { RefundsSummary } from "./RefundsSummary";
import { TopUpsSummary } from "./TopUpsSummary";
import { TransfersSummary } from "./TransfersSummary";

const todayMaxDate = moment().format(appConfig.javascriptCodeDateFormat);
const switchAppOpsMinDate = moment("Dec 1, 2022").format(
  appConfig.javascriptCodeDateFormat,
);

export const View = ({
  activeCurrency,
  customChartPeriod,
  navigateToRoute,
  setStartChartPeriodFromDatePicker,
  setEndChartPeriodFromDatePicker,
}: IHomeViewProps) => {
  return (
    <>
      <div className="flex-container row justify-content--end mb-5 mr-5">
        <div className="flex-container align-items--center">
          <strong className="text-secondary mr-5">From </strong>
          <DatePicker
            name="statementStartPeriod"
            label="Start Period"
            placeholder={customChartPeriod.startDate ?? "Start Period"}
            defaultValue={customChartPeriod.startDate ?? null}
            onChange={(date) =>
              setStartChartPeriodFromDatePicker(
                moment(new Date(date)).format(
                  appConfig.javascriptCodeDateFormat,
                ),
              )
            }
            maxDate={todayMaxDate}
            minDate={switchAppOpsMinDate}
          />
        </div>

        <div className="flex-container align-items--center">
          <strong className="text-secondary ml-5 mr-5">To </strong>

          <div className="ml-5">
            <DatePicker
              name="statementEndPeriod"
              label="End Period"
              placeholder={customChartPeriod.endDate ?? "End Period"}
              defaultValue={customChartPeriod.endDate ?? null}
              onChange={(date) =>
                setEndChartPeriodFromDatePicker(
                  moment(new Date(date)).format(
                    appConfig.javascriptCodeDateFormat,
                  ),
                )
              }
              maxDate={todayMaxDate}
              minDate={switchAppOpsMinDate}
            />
          </div>
        </div>
      </div>

      <div className="summaries-container">
        <div className="flex-container row flex-break--small justify-content--start align-items--stretch">
          <MerchantsSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />

          <PaymentsSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />

          <TopUpsSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />
        </div>

        <div className="flex-container row flex-break--small justify-content--start align-items--stretch">
          <TransfersSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />

          <PayoutsSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />

          <RefundsSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />
        </div>

        <div className="flex-container row flex-break--small justify-content--start align-items--start">
          <CustomersSummary
            activeCurrency={activeCurrency}
            customChartPeriod={customChartPeriod}
          />

          <div className="placeholder flex-box summary-section" />
          <div className="placeholder flex-box summary-section" />
          {/* <ProductsSummary activeCurrency={activeCurrency} />

        <PaymentLinksSummary activeCurrency={activeCurrency} /> */}
        </div>
      </div>
    </>
  );
};
